import {
  BaseImportMetadata,
  CompletedImport,
  CompletedImportMetadata,
  FailedImport,
  FailedImportMetadata,
  PendingImport,
  EntityLabel
} from '@esg/esg-global-types';
import { Timestamp } from 'firebase/firestore';

// Singular and plural label for model entity.
export const import_label: EntityLabel = {
  one: 'Import',
  many: 'Imports'
};

// Singular and plural label for import types.
export const import_type_label: EntityLabel = {
  one: 'Import Type',
  many: 'Import Types'
};

export type BaseImportMetadataModalData = Omit<BaseImportMetadata, 'started'> & {
  started: Timestamp;
};

export type FailedImportMetadataModalData = Omit<FailedImportMetadata, 'started' | 'failed'> & {
  started: Timestamp;
  failed: Timestamp;
};

export type CompletedImportMetadataModalData = Omit<
  CompletedImportMetadata,
  'started' | 'completed'
> & {
  started: Timestamp;
  completed: Timestamp;
};

export type PendingImportModalData = Omit<PendingImport, 'id' | 'metadata'> & {
  metadata: BaseImportMetadataModalData;
};

export type FailedImportModalData = Omit<FailedImport, 'id' | 'metadata'> & {
  metadata: FailedImportMetadataModalData;
};

export type CompletedImportModalData = Omit<CompletedImport, 'id' | 'metadata'> & {
  metadata: CompletedImportMetadataModalData;
};
